<template>
  <div>
    <br />
    <div class="row align-items-end">
      
      <div class="col-xl-3 col-12">
        <label for="">Produit</label>

        <vue-select :options="items" v-model="productionItem.item_reference" placeholder="Select an option"
          labelColumn="fullName" valueColumn="reference" />

 
      </div>

     

      <div class="col-xl-2 col-12">
        <label for=""> Quantité </label>
        <input type="text" v-model="productionItem.quantity" class="form-control" />
      </div>

       <div class="col-xl-2 col-12">
        <label for=""> NB </label>
        <input type="text" v-model="productionItem.remark" class="form-control" />
      </div>

      <div class="col-xl-auto col">
        <label for=""></label>
        <button class="btn btn-success" @click="save(productionItem)">
          <i class="bi bi-plus-circle"></i> Enregistrer
        </button>
      </div>

      <div class="col-xl-auto col-auto">
        <button class="btn btn-secondary d-flex align-items-center" @click="refresh()">
          <i class="bi bi-arrow-clockwise fs-4 me-2"></i>
          <span> Actualiser </span>
        </button>
      </div>
    </div>
    <br />

    <vue-data-table v-if="production.productionItems" :headers="headers" :data="production.productionItems" :items-per-page="10"
      :buttons="buttons" :summable-columns="summableColumns">

      



    </vue-data-table>

    <br />
    <div class="row mt-3 justify-content-between align-items-center">
      <div class="col-xl-8 col-12">

      </div>
      <div class="col-xl-auto col-12">
        <button class="btn btn-success" @click="validated()">
          <i class="bi bi-arrow-right-circle"></i> Suivant
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      productionItem: {
        id: "",
        item_reference: "",
        production_reference: "",
        quantity: "",
      },
      // Table headers configuration
      headers: [
        { field: 'itemFullName', label: 'Désignation', class: '' },
        { field: 'quantity', label: 'Quantité', class: 'fw-bold' },
        { field: 'userFullName', label: 'Créer par', class: '' },
      ],
      // Button actions
      buttons: [
        {
          label: 'Modifier',
          icon: 'bi bi-pencil',
          class: 'btn btn-warning',
          action: (item) => {
            this.editItem(item);
          },
        },
        {
          label: 'Supprimer',
          icon: 'bi bi-trash',
          class: 'btn btn-danger',
          action: (item) => {
            this.deleteItem(item);
          },
        },
      ],
      // Columns to summarize
      summableColumns: [
        { field: 'quantity', class: 'fw-bold' },
      ],

    };
  },
  computed: {
    ...mapGetters("item", {
      items: "getAll",
    }),

    ...mapGetters("production", {
      production: "getProduction",
    }),

  },
  methods: {
    async save(data) {
      if (data.id === "") {

        await (data.production_reference = this.production.reference);

        await this.$store.dispatch("production/storeItem", data);

        await (this.productionItem = {
          id: "",
          item_reference: "",
          production_reference: "",
          quantity: "",
        });
        
        await this.$store.dispatch("production/show", this.$route.params.reference);

      }
      else {

        await (data.production_reference = this.production.reference);

        await this.$store.dispatch("production/updateItem", data);
        await (this.productionItem = {
          id: "",
          item_reference: "",
          production_reference: "",
          quantity: "",
        });
      }
    },

    async refresh() {
      await this.$store.dispatch("section/getAll");
      await this.$store.dispatch("item/getAll");
      await this.$store.dispatch("production/show", this.$route.params.reference);
    },
    async validated() {
      this.$router.push({
        name: "productions-edit", params: {
          reference: this.$route.params.reference
        }
      });
    },

    async editItem(item) {
      await (this.productionItem.id = item.id)
      await (this.productionItem.item_reference = item.item_reference)
      await (this.productionItem.quantity = item.quantity)
      // Add your editing logic here
    },
    async deleteItem(item) {
      await this.$store.dispatch("production/destroyItem", item.id);
    },
  },
  async mounted() {
    await this.$store.dispatch("section/getAll");
    await this.$store.dispatch("item/getAll");
    await this.$store.dispatch("production/show", this.$route.params.reference);
  },
};
</script>
<style scoped></style>